const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';

export const IS_FIREFOX = /Firefox\//.test(userAgent);
export const IS_APPLE = /Mac OS X/.test(userAgent);
export const IS_MOBILE = /Mobile/.test(userAgent);
export const IS_PLAYWRIGHT = /Playwright/.test(userAgent);
export const IS_WINDOWS = /Windows/.test(userAgent);
export const IS_CYPRESS = typeof window !== 'undefined' && 'Cypress' in window;
